import { CreateContractRequestBody, IDENTIFICATION_METHODS } from '@boltenergy-be/shared'
import { InputGroups } from 'store/customer/types'
import { store } from 'store'
import { Producer } from 'types/producer'
import { AllProducts } from 'types/product-data'
import { MeterDetailsFieldKeys } from 'store/customer/enums'
import { parseCreateCustomerData } from 'lib/bolt-backend/registrations/createCustomer.utils'

export const parseCreateContractData = async (producer: Producer, allProducts: AllProducts): Promise<CreateContractRequestBody> => {
  // Fetch data from the redux store
  const { inputs, extraAddress } = store.getState().customer
  const marketingStore = store.getState().marketing
  const { meterDetails, personalData } = inputs as InputGroups

  // Create Contract data has a lot of overlap with create customer data
  const { meter, account, marketing, ...createCustomerData } = await parseCreateCustomerData(producer, allProducts)

  // Map & return the create contract data
  return {
    ...createCustomerData,
    account: {
      customerNumber: extraAddress?.selectedAccount,
      ...account,
      company: account.company?.enterpriseNumber
        ? {
            ...account.company,
            creditCheck: personalData?.companyNumber ? marketingStore.executeCreditCheck : undefined
          }
        : undefined
    },
    marketing: {
      ...marketing,
      identificationMethod: IDENTIFICATION_METHODS.default
    },
    meter: {
      ...meter,
      electricity: {
        ...meter.electricity,
        ean: meterDetails[MeterDetailsFieldKeys.ELECTRICITY].ean.toString()
      },
      gas: meter.gas
        ? {
            ...meter.gas,
            ean: meterDetails[MeterDetailsFieldKeys.GAS].ean.toString()
          }
        : undefined
    }
  } satisfies CreateContractRequestBody
}
